import { render, staticRenderFns } from "./OrderShipsWithOrders.vue?vue&type=template&id=870d5df2"
import script from "./OrderShipsWithOrders.vue?vue&type=script&lang=ts"
export * from "./OrderShipsWithOrders.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports